"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InputErrorMessage = require("./InputErrorMessage");

var _InputErrorMessage2 = _interopRequireDefault(_InputErrorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _InputErrorMessage2.default;